import fetchJson from "@/lib/fetchJson";
import useSWR from "swr";
import { isValidId } from "@/lib/util";

type DuplicateType = Post & { campaign: Campaign };
export const useDuplicates = () =>
  useSWR<DuplicateType[][]>("/post/duplicates", fetchJson);

export const deletePost = async (id: number) => {
  await fetchJson(`/post/${id}`, {
    method: "DELETE",
  });
};

export const usePostHistory = (id: string | undefined) =>
  useSWR(isValidId(id) ? `/post/${id}/history` : null, fetchJson);

export const useSpotifyPlaylists = () =>
  useSWR(`/post/spotify-playlist`, fetchJson);

export const getXPostByHashtag = async (hashtag: string) => {
  return await fetchJson(`/post/x-hashtag?hashtag=${encodeURIComponent(hashtag)}`);
}
